import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

// The support page the App Store listing points at. Plain answers to the
// questions people actually have, in the order they have them: getting the
// pet into Minecraft, then what to do when something does not show up.
export default function Support() {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-card card">
          <h1>Support</h1>
          <p className="legal-updated">
            Stuck? Email <a href="mailto:hello@petlings.gg">hello@petlings.gg</a> or ask on the{' '}
            <a href="https://discord.gg/hkcNBCTckG" target="_blank" rel="noopener noreferrer">Discord</a>.
            We answer within a day or two.
          </p>

          <section>
            <h2>Getting started</h2>
            <ol>
              <li>Get Petlings on the App Store, or sign up here at petlings.gg. The same account works everywhere.</li>
              <li>Adopt a petling. Feed it, play with it, grow it a garden.</li>
              <li>To bring it into Minecraft, link your Minecraft account and install the mod (below).</li>
            </ol>
          </section>

          <section>
            <h2>Playing together in Minecraft</h2>
            <p>Petlings works with <strong>Minecraft: Java Edition</strong> through the free Petlings mod, built for Fabric.</p>
            <ol>
              <li>Install the <a href="https://fabricmc.net/use/installer/" target="_blank" rel="noopener noreferrer">Fabric Loader</a> for your Minecraft version, and the Fabric API mod.</li>
              <li>Download the Petlings mod for your version from <a href="https://modrinth.com/mod/petlings" target="_blank" rel="noopener noreferrer">Modrinth</a> and put the .jar in your <code>mods</code> folder.</li>
              <li>In the app, open <strong>Profile &rsaquo; Minecraft</strong> (or the Minecraft bar on the pet's home page) and tap <strong>Link account</strong>. You get a short code.</li>
              <li>In Minecraft, open the Petlings menu and enter the code. Your pet appears beside you.</li>
            </ol>
            <p>
              Your pet keeps a journal of what you do together in the game: places you find, close calls, diamonds, the nights you
              make it through. It shows up in the app under Minecraft, and your pet will talk about it. Moments arrive within about a
              minute of happening, and when you leave the game.
            </p>
            <p>
              Petlings is not an official Minecraft product and is not approved by or associated with Mojang or Microsoft.
            </p>
          </section>

          <section>
            <h2>Common questions</h2>
            <h3>My pet does not appear in the game</h3>
            <ul>
              <li>Check the mod is loaded: the Petlings menu should be in the pause menu. If it is missing, the .jar is in the wrong folder or is for a different Minecraft version.</li>
              <li>Check you are signed in inside the mod (the account button at the top of the Petlings menu). Linking has to be done once, in the app.</li>
              <li>On a server, other players see your pet only if the server allows it. Singleplayer always works.</li>
            </ul>

            <h3>The journal is empty after I played</h3>
            <ul>
              <li>Make sure the mod is signed in to the same account as the app.</li>
              <li>Wait a minute after something happens, then pull down on the Minecraft page in the app to refresh.</li>
              <li>Quiet play does not write much. Try a new biome, a portal, or a close call.</li>
            </ul>

            <h3>Linking says my Minecraft account is already linked</h3>
            <p>
              A Minecraft account can be linked to one Petlings account at a time. Unlink it from the other account first
              (Profile &rsaquo; Minecraft &rsaquo; Unlink), or email us if you no longer have access to that account.
            </p>

            <h3>Unlinking</h3>
            <p>
              Unlinking keeps everything on your Petlings account: pets, gardens, treats, purchases and conversations. The
              Minecraft account starts fresh and can be linked again after a month.
            </p>

            <h3>Voice does not work</h3>
            <p>
              Voice is push-to-talk: hold the microphone button while you speak. The app needs the Microphone and Speech
              Recognition permissions (Settings &rsaquo; Petlings). Speech is turned into text on your phone where the device supports it.
            </p>

            <h3>Treats or a purchase did not arrive</h3>
            <p>
              Purchases made in the app go through the App Store and are added to your account when the App Store confirms them,
              usually at once. If treats are missing, open the app while online, wait a moment, and check again. Still missing?
              Email us with the App Store receipt.
            </p>

            <h3>Ages and what the pet knows</h3>
            <p>
              Petlings is for players 10 and up. The app asks your age at the start. Younger players get a pet that never asks for
              personal details and never nags. There are no timers or streaks, and nothing is lost for staying away.
            </p>

            <h3>Deleting your account</h3>
            <p>
              In the app: Profile &rsaquo; Settings &rsaquo; Delete account. This removes your account and everything held for it. You can
              also email <a href="mailto:privacy@petlings.gg">privacy@petlings.gg</a>.
            </p>
          </section>

          <section>
            <h2>More</h2>
            <p>
              <Link to="/privacy">Privacy policy</Link> &middot; <Link to="/terms">Terms</Link> &middot; <Link to="/about">About Petlings</Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
